import React, {Component, PropTypes} from 'react'
import {Media} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {timeAgo} from '../../../utils/dateHelper'
import {Link} from 'react-router'
import ProgressBar from '../../Common/ProgressBar/ProgressBar'
import {FaMagnet, IoIosPulseStrong, MdReport, MdPhoto, MdFavorite, MdErrorOutline, MdKeyboardArrowUp, MdKeyboardArrowDown} from '../../Common/ReactIcons/icons'

class NotificationComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      details: null,
      isRead: props.item.isRead,
      isOpen: false,
      isLoading: false
    }
    this.loadMore = this.loadMore.bind(this)
  }

  loadMore (id) {
    this.setState({isOpen: !this.state.isOpen})
    if (this.state.details === null) {
      this.setState({isOpen: false, forceComplete: false, isLoading: true})
      Actions.notificationInfo(id).then((res) => {
        this.setState({details: res.data, isRead: true, isOpen: true, isLoading: false})
      })
    }
  }

  render () {
    const {item} = this.props

    const {details, isLoading, isRead, isOpen} = this.state

    const icon = (type) => {
      switch (type) {
        case 'horse_report' :
          return <MdReport />
        case 'horse_report_die' :
          return <IoIosPulseStrong />
        case 'horse_report_photo' :
          return <MdReport />
        case 'horse_add_photo' :
          return <MdPhoto />
        case 'horse_add_new' :
          return <FaMagnet />
        case 'horse_like' :
          return <MdFavorite />
        case 'other' :
        default :
          return <MdErrorOutline />
      }
    }

    const redirectLink = (type, params) => {
      if (params === null) return null
      switch (type) {
        case 'horse_report' :
        case 'horse_report_die' :
        case 'horse_report_photo' :
        case 'horse_add_photo' :
        case 'horse_add_new' :
        case 'horse_like' :
          return <Link to={`/horse/${params.horse_key}`} className="redirect-link">برای ارجاع به اسب مورد نظر اینجا کلیک کنید.</Link>
        default :
          return null
      }
    }

    return (
      <Media className={!isRead && 'unread'} onClick={(e) => this.loadMore(item.id)}>
        <ProgressBar isLoading={isLoading} />
        <Media.Left>
          {icon(item.type)}
        </Media.Left>
        <Media.Body>
          <Media.Heading className="title">
            {item.title}
            <span className="arrow">{isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}</span>
          </Media.Heading>
          <date className="time">{timeAgo(item.date)}</date>
          <div className={isOpen ? 'discription' : 'hide discription'}>
            {details && <div>
              <div dangerouslySetInnerHTML={{__html: details.description}} />
              {redirectLink(item.type, details.params)}
            </div>}
          </div>
        </Media.Body>
      </Media>
    )
  }
}

NotificationComponent.propTypes = {
  item: PropTypes.object.isRequired,
  loader: PropTypes.func.isRequired
}

export default NotificationComponent



// WEBPACK FOOTER //
// ./src/components/User/Notification/NotificationComponent.js